import { CONTEST_SET_PAGES_IN_BRACKET } from 'actions/contest';

const DEFAULT_STATE = {
  pages: {}
};

export default function app(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case CONTEST_SET_PAGES_IN_BRACKET:
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.data.bracket]: action.data.pages
        }
      };
    default:
      return state;
  }
}
